
(function () {
if (customElements.get('rnb-cedar-hero')) return;
class RnbCedarHero extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
this.form = this.querySelector('product-form form');
this.idInput = this.querySelector('product-form input[name="id"]');

this.submitBtn = this.querySelector('product-form button[name="add"]');
this.errorEl = this.querySelector('[data-rnb-cedar-error]');
this.initGallery();
this.initAccordions();


this.initSticky();
}
initGallery() {
const track = this.querySelector('[data-slides]');
if (!track) return;
this.track = track;
this.slides = Array.from(track.children);
this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
this.thumbBox = this.querySelector('[data-thumbs]');
this.prevBtn = this.querySelector('[data-thumb-prev]');
this.nextBtn = this.querySelector('[data-thumb-next]');
this.active = 0;
this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.goTo(parseInt(btn.dataset.thumb, 10))));
if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.active - 1));
if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.active + 1));
let ticking = false;
track.addEventListener('scroll', () => {
if (ticking) return;
ticking = true;
requestAnimationFrame(() => {
ticking = false;
const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
if (i !== this.active) this.setActive(i);
});
}, { passive: true });
this.setActive(0, true);
this.initStickyGallery();
}
initStickyGallery() {
const g = this.querySelector('.rnb-cedar-hero__gallery.is-sticky');
if (!g) return;
const base = parseInt(getComputedStyle(this).getPropertyValue('--rnb-cedar-sticky-top'), 10) || 0;
const reserve = this.querySelector('[data-rnb-cedar-sticky]') || document.getElementById('RnbCedarSticky-' + this.dataset.section) ? 90 : 20;
const fit = () => {
if (window.innerWidth < 750) { g.style.top = ''; return; }
const top = Math.min(base, window.innerHeight - g.offsetHeight - reserve);
g.style.top = top + 'px';
};
fit();
window.addEventListener('resize', fit, { passive: true });
if ('ResizeObserver' in window) new ResizeObserver(fit).observe(g);
}
goTo(i) {
if (!this.slides || !this.slides.length) return;
i = Math.max(0, Math.min(this.slides.length - 1, i));
this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
this.setActive(i);
}
setActive(i, silent) {
this.active = i;
this.thumbs.forEach((t, n) => {
const on = n === i;
t.classList.toggle('is-active', on);
if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
});
if (this.prevBtn) this.prevBtn.disabled = i <= 0;
if (this.nextBtn) this.nextBtn.disabled = i >= this.slides.length - 1;
const thumb = this.thumbs[i];
if (thumb && this.thumbBox && !silent) {
const left = thumb.offsetLeft - (this.thumbBox.clientWidth - thumb.clientWidth) / 2;
this.thumbBox.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
}
}
initAccordions() {
const items = Array.from(this.querySelectorAll('[data-rnb-cedar-acc]'));
items.forEach((item) => {
const head = item.querySelector('.rnb-cedar-acc__head');
head.addEventListener('click', () => {
const open = !item.classList.contains('is-open');
items.forEach((other) => {
if (other !== item && other.classList.contains('is-open')) {
other.classList.remove('is-open');
other.querySelector('.rnb-cedar-acc__head').setAttribute('aria-expanded', 'false');
}
});
item.classList.toggle('is-open', open);
head.setAttribute('aria-expanded', String(open));
});
});
}
initShipDate() {
this.querySelectorAll('[data-rnb-cedar-shipdate]').forEach((el) => {
const days = parseInt(el.dataset.days, 10) || 0;
const skip = el.dataset.skipWeekends === 'true';
const cutoff = parseInt(el.dataset.cutoff, 10);
const d = new Date();
let add = days;
if (!isNaN(cutoff) && cutoff > 0 && d.getHours() >= cutoff) add += 1;
while (add > 0) {
d.setDate(d.getDate() + 1);
if (skip && (d.getDay() === 0 || d.getDay() === 6)) continue;
add -= 1;
}
while (skip && (d.getDay() === 0 || d.getDay() === 6)) d.setDate(d.getDate() + 1);
const lang = document.documentElement.lang || 'en-US';
try {
el.textContent = d.toLocaleDateString(lang, { weekday: 'short', month: 'long', day: 'numeric' });
} catch (e) {
el.textContent = d.toDateString();
}
});
}
initSticky() {
const bar = this.querySelector('[data-rnb-cedar-sticky]');
const toTop = this.querySelector('[data-rnb-cedar-totop]');
if (bar && bar.parentElement !== document.body) document.body.appendChild(bar);
if (toTop && toTop.parentElement !== document.body) document.body.appendChild(toTop);
this.bar = bar;
this.toTop = toTop;
if (bar) {
const btn = bar.querySelector('[data-rnb-cedar-sticky-btn]');
btn.addEventListener('click', () => {
if (this.form && this.submitBtn && !this.submitBtn.disabled) this.submitBtn.click();
});
if (this.submitBtn && 'IntersectionObserver' in window) {
const io = new IntersectionObserver((entries) => {
entries.forEach((entry) => {
const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
bar.classList.toggle('is-visible', passed);
bar.setAttribute('aria-hidden', String(!passed));
btn.tabIndex = passed ? 0 : -1;
if (toTop) toTop.classList.toggle('is-raised', passed);
});
}, { threshold: 0 });
io.observe(this.submitBtn);
}
}
if (toTop) {
toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
const onScroll = () => toTop.classList.toggle('is-visible', window.scrollY > 700);
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
}
}
disconnectedCallback() {
if (this.bar && this.bar.parentElement === document.body) this.bar.remove();
if (this.toTop && this.toTop.parentElement === document.body) this.toTop.remove();
}
}
customElements.define('rnb-cedar-hero', RnbCedarHero);
})();


(function () {
if (customElements.get('rnb-cedar-slider')) return;
class RnbCedarSlider extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
this.track = this.querySelector('[data-track]');
if (!this.track) return;
this.prevBtn = this.querySelector('[data-prev]');
this.nextBtn = this.querySelector('[data-next]');
this.dotsEl = this.querySelector('[data-dots]');
if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
let ticking = false;
this.track.addEventListener('scroll', () => {
if (ticking) return;
ticking = true;
requestAnimationFrame(() => { ticking = false; this.update(); });
}, { passive: true });
if ('ResizeObserver' in window) {
this.ro = new ResizeObserver(() => this.build());
this.ro.observe(this.track);
} else {
window.addEventListener('resize', () => this.build());
}
this.build();
}
disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
positions() {
const t = this.track;
const max = Math.max(0, t.scrollWidth - t.clientWidth);
const kids = Array.from(t.children).filter((k) => k.offsetParent !== null || k.getClientRects().length);
const first = kids.length ? kids[0].offsetLeft : 0;
const pos = [];
kids.forEach((k) => {
const l = Math.min(Math.max(0, k.offsetLeft - first), max);
if (!pos.length || l - pos[pos.length - 1] > 4) pos.push(l);
});
if (!pos.length) pos.push(0);
if (max - pos[pos.length - 1] > 4) pos.push(max);
return pos;
}
build() {
this.pos = this.positions();
const many = this.pos.length > 1;
this.classList.toggle('is-static', !many);
if (this.dotsEl) {
this.dotsEl.innerHTML = '';
this.dotsEl.hidden = !many;
if (many) {
this.pos.forEach((p, i) => {
const b = document.createElement('button');
b.type = 'button';
b.className = 'rnb-cedar-dot';
b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
b.addEventListener('click', () => this.go(i));
this.dotsEl.appendChild(b);
});
}
}
this.update();
}
index() {
const x = this.track.scrollLeft;
let best = 0;
let dist = Infinity;
this.pos.forEach((p, i) => { const d = Math.abs(p - x); if (d < dist) { dist = d; best = i; } });
return best;
}
go(i) {
i = Math.max(0, Math.min(this.pos.length - 1, i));
this.track.scrollTo({ left: this.pos[i], behavior: 'smooth' });
}
step(dir) { this.go(this.index() + dir); }
update() {
if (!this.pos) return;
const i = this.index();
const x = this.track.scrollLeft;
const max = this.track.scrollWidth - this.track.clientWidth;
if (this.dotsEl) Array.from(this.dotsEl.children).forEach((d, n) => {
d.classList.toggle('is-active', n === i);
if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
});
if (this.prevBtn) this.prevBtn.disabled = x <= 2;
if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
}
}
customElements.define('rnb-cedar-slider', RnbCedarSlider);
})();
(function () {
if (customElements.get('rnb-cedar-reel')) return;
class RnbCedarReel extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
this.video = this.querySelector('video');
const play = this.querySelector('[data-reel-play]');
const toggle = this.querySelector('[data-reel-toggle]');
const mute = this.querySelector('[data-reel-mute]');
if (!this.video) {
if (play) play.setAttribute('aria-disabled', 'true');
return;
}
this.video.removeAttribute('controls');
this.video.muted = this.classList.contains('is-muted');
if (play) play.addEventListener('click', () => this.play());
if (toggle) toggle.addEventListener('click', () => (this.video.paused ? this.play() : this.video.pause()));
if (mute) mute.addEventListener('click', (e) => {
e.stopPropagation();
this.video.muted = !this.video.muted;
this.classList.toggle('is-muted', this.video.muted);
});
this.video.addEventListener('play', () => this.classList.add('is-playing'));
this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
this.video.addEventListener('ended', () => this.classList.remove('is-playing'));
}
play() {
document.querySelectorAll('rnb-cedar-reel').forEach((r) => { if (r !== this && r.video && !r.video.paused) r.video.pause(); });
const p = this.video.play();
if (p && p.catch) p.catch(() => {
this.video.muted = true;
this.classList.add('is-muted');
this.video.play();
});
}
}
customElements.define('rnb-cedar-reel', RnbCedarReel);
})();


(function () {
if (customElements.get('rnb-cedar-slider')) return;
class RnbCedarSlider extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
this.track = this.querySelector('[data-track]');
if (!this.track) return;
this.prevBtn = this.querySelector('[data-prev]');
this.nextBtn = this.querySelector('[data-next]');
this.dotsEl = this.querySelector('[data-dots]');
if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
let ticking = false;
this.track.addEventListener('scroll', () => {
if (ticking) return;
ticking = true;
requestAnimationFrame(() => { ticking = false; this.update(); });
}, { passive: true });
if ('ResizeObserver' in window) {
this.ro = new ResizeObserver(() => this.build());
this.ro.observe(this.track);
} else {
window.addEventListener('resize', () => this.build());
}
this.build();
}
disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
positions() {
const t = this.track;
const max = Math.max(0, t.scrollWidth - t.clientWidth);
const kids = Array.from(t.children).filter((k) => k.offsetParent !== null || k.getClientRects().length);
const first = kids.length ? kids[0].offsetLeft : 0;
const pos = [];
kids.forEach((k) => {
const l = Math.min(Math.max(0, k.offsetLeft - first), max);
if (!pos.length || l - pos[pos.length - 1] > 4) pos.push(l);
});
if (!pos.length) pos.push(0);
if (max - pos[pos.length - 1] > 4) pos.push(max);
return pos;
}
build() {
this.pos = this.positions();
const many = this.pos.length > 1;
this.classList.toggle('is-static', !many);
if (this.dotsEl) {
this.dotsEl.innerHTML = '';
this.dotsEl.hidden = !many;
if (many) {
this.pos.forEach((p, i) => {
const b = document.createElement('button');
b.type = 'button';
b.className = 'rnb-cedar-dot';
b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
b.addEventListener('click', () => this.go(i));
this.dotsEl.appendChild(b);
});
}
}
this.update();
}
index() {
const x = this.track.scrollLeft;
let best = 0;
let dist = Infinity;
this.pos.forEach((p, i) => { const d = Math.abs(p - x); if (d < dist) { dist = d; best = i; } });
return best;
}
go(i) {
i = Math.max(0, Math.min(this.pos.length - 1, i));
this.track.scrollTo({ left: this.pos[i], behavior: 'smooth' });
}
step(dir) { this.go(this.index() + dir); }
update() {
if (!this.pos) return;
const i = this.index();
const x = this.track.scrollLeft;
const max = this.track.scrollWidth - this.track.clientWidth;
if (this.dotsEl) Array.from(this.dotsEl.children).forEach((d, n) => {
d.classList.toggle('is-active', n === i);
if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
});
if (this.prevBtn) this.prevBtn.disabled = x <= 2;
if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
}
}
customElements.define('rnb-cedar-slider', RnbCedarSlider);
})();


(function () {
if (customElements.get('rnb-cedar-tabs')) return;
class RnbCedarTabs extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
this.panels = Array.from(this.querySelectorAll('[data-panel]'));
this.tabs.forEach((tab, i) => {
tab.addEventListener('click', () => this.show(i));
tab.addEventListener('keydown', (e) => {
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.show((i + 1) % this.tabs.length, true); }
if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.show((i - 1 + this.tabs.length) % this.tabs.length, true); }
});
});
document.addEventListener('shopify:block:select', (e) => {
const idx = this.tabs.findIndex((t) => t.id === 'RnbCedarDetTab-' + e.detail.blockId);
if (idx > -1) this.show(idx);
});
}
show(i, focus) {
this.tabs.forEach((t, n) => {
const on = n === i;
t.classList.toggle('is-active', on);
t.setAttribute('aria-selected', String(on));
t.tabIndex = on ? 0 : -1;
if (on && focus) t.focus();
});
this.panels.forEach((p, n) => {
const on = n === i;
p.hidden = !on;
p.classList.toggle('is-active', on);
});
}
}
customElements.define('rnb-cedar-tabs', RnbCedarTabs);
})();


(function () {
if (customElements.get('rnb-cedar-faq')) return;
class RnbCedarFaq extends HTMLElement {
connectedCallback() {
if (this._ready) return;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
else this.init();
}
init() {
if (this._ready) return;
this._ready = true;
const single = this.dataset.single !== 'false';
const items = Array.from(this.querySelectorAll('[data-faq-item]'));
items.forEach((item) => {
const btn = item.querySelector('.rnb-cedar-faq__q');
btn.addEventListener('click', () => {
const open = !item.classList.contains('is-open');
if (single) items.forEach((o) => {
if (o !== item && o.classList.contains('is-open')) {
o.classList.remove('is-open');
o.querySelector('.rnb-cedar-faq__q').setAttribute('aria-expanded', 'false');
}
});
item.classList.toggle('is-open', open);
btn.setAttribute('aria-expanded', String(open));
});
});
}
}
customElements.define('rnb-cedar-faq', RnbCedarFaq);
})();
